<template>
    <div class="portal-indicator">
        <span v-for="portal in portals" :style="{'background-color': all[portal]}">
        </span>
    </div>
</template>

<script>
export default {
    props: [
        'tags'
    ],

    data() {
        return {
            all: {
                pef: '#b71b2d',
                fzp: '#1c949f',
                sen: '#f0913b'
            }
        }
    },

    computed: {
        portals() {
            return Object.keys(this.tags).filter(item => item in this.all);
        }
    }
}
</script>

<style>
    .portal-indicator span {
        display: inline-block;
        margin: 1px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
</style>
